var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.244,
    height: 73.904,
    viewBox: "0 0 66.244 73.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74660",
    "data-name": "Group 74660",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M-19233.5-17159.809l1.934,8.984,6.014,4.006h5.666l3.111-1.656s2.418-2.9,2.625-3.041,2.764-3.525,2.764-3.525v-4.768Z",
    transform: "translate(19255.537 17217.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M-19225.148-17217.578l-12.449,2.275-8.2,11.084-.912,9.109v11.08l-.912,12-3.947,6.227-2.732,4.705h8.5c1.061,0,51.768.758,51.768.758l.758-3.492-5.465-8.2-1.365-21.711-.762-10.475-5.918-8.5-9.719-3.793-9.715-1.064Z",
    transform: "translate(19256.832 17220.789)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M19.686,19.375a26.322,26.322,0,0,1,49.051,8c.778,7.867-.028,15.8.431,23.686,1.069,4.285,4.989,7.136,6.564,11.224.844,2.635-.928,6.208-3.9,6.376-5.317.375-10.652.009-15.978.159-1.3,5.973-6.817,10.877-13.062,10.69-6.226.169-11.693-4.745-13.006-10.7-5.364-.141-10.746.244-16.1-.169-2.888-.244-4.6-3.77-3.779-6.358,1.538-3.807,4.885-6.573,6.4-10.408,1.378-10.755-2.157-22.542,3.385-32.5m19.138-8.1A21.248,21.248,0,0,0,21.759,30.421c-.272,7.361.216,14.731-.206,22.083-.956,4.285-4.3,7.511-6.63,11.1q27.892.1,55.793,0c-2.335-3.619-5.682-6.855-6.676-11.159-.506-7.961.291-15.978-.384-23.939C62.023,17.191,50.021,8.761,38.825,11.274m-3.854,57.64c1.763,2.719,4.332,5.4,7.839,5.392,3.516.028,6.1-2.663,7.849-5.429C45.436,68.764,40.2,68.735,34.971,68.914Z",
    transform: "translate(-9.699 -5.611)",
    fill: "#ebebeb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notificationBell.b21b24f76bd816735901c84c71c66540.svg";
export { ForwardRef as ReactComponent };